const config = {
    API_URL: process.env.VUE_APP_API_URL,
    STORAGE_URL: process.env.VUE_APP_STORAGE_URL
}

export default config;  